module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og lulesamisk_sekundærlogo_neg(hvit).2defdaad.png";